import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPublicInfo } from '../api/platform';

export const DEFAULT_PANEL_NAME = 'xcodec';
const DEFAULT_FAVICON = '/favicon.svg';

// Branding is public (the login page needs it before sign-in), so every
// screen reads the same cached query.
export function useBranding() {
  const { data } = useQuery({
    queryKey: ['public-info'],
    queryFn: getPublicInfo,
    staleTime: 5 * 60_000,
  });
  return {
    name: data?.platform_name?.trim() || DEFAULT_PANEL_NAME,
    logoUrl: data?.logo_url || '',
    faviconUrl: data?.favicon_url || '',
  };
}

// BrandingEffect keeps the browser tab in step with the settings: the server
// renders the first paint, this follows changes made while the panel is open.
export function BrandingEffect() {
  const { name, faviconUrl } = useBranding();

  useEffect(() => {
    document.title = name;
  }, [name]);

  useEffect(() => {
    const existing = document.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
    const link = existing ?? document.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl || DEFAULT_FAVICON;
    if (!existing) document.head.appendChild(link);
  }, [faviconUrl]);

  return null;
}
